import { module } from 'angular';
import { MANIFEST_WRITER } from 'core/manifest/manifestWriter.service';

export const MANIFEST_MODULE = 'spinnaker.core.manifest';
module(MANIFEST_MODULE, [
  MANIFEST_WRITER,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/manifest/manifestWriter.module.ts